import type { ChatSessionMessage } from '../model/types'

import { CopyIcon, ThumbsDownIcon, ThumbsUpIcon } from 'lucide-react'
import { toast } from 'sonner'
import { useCopyToClipboard } from 'usehooks-ts'

import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

import { useAssistantConversation } from '../lib/useAssistantConversation'

export default function ChatMessageActions({
	vote,
	message,
}: {
	vote?: 'like' | 'dislike'
	message: ChatSessionMessage
}) {
	const [, copy] = useCopyToClipboard()
	const { messageReaction } = useAssistantConversation()
	const isRated = vote === 'like' || vote === 'dislike'

	return (
		<div
			className={cn(
				'flex items-center gap-1 opacity-0 transition-opacity duration-300 group-hover/message:opacity-100',
				{
					'opacity-100': isRated,
				}
			)}
		>
			<Button
				data-testid='chat-bot-message-copy'
				size='icon-sm'
				data-active={vote === 'like'}
				onClick={() => {
					copy(message.text)
					toast.success('Copied to clipboard')
				}}
			>
				<CopyIcon />
			</Button>
			<Button
				data-testid='chat-bot-message-like'
				size='icon-sm'
				data-active={vote === 'like'}
				onClick={() => !vote && messageReaction(message.id, 'like')}
			>
				<ThumbsUpIcon className={vote === 'like' ? 'fill-current' : ''} />
			</Button>
			<Button
				data-testid='chat-bot-message-dislike'
				size='icon-sm'
				data-active={vote === 'dislike'}
				onClick={() => !vote && messageReaction(message.id, 'dislike')}
			>
				<ThumbsDownIcon className={vote === 'dislike' ? 'fill-current' : ''} />
			</Button>
		</div>
	)
}
